module.exports = __webpack_public_path__ + "img/Medical_Case_pic04.663b2497.jpg";